import { Link } from "react-router-dom";
import useAgentAnalyticsQuery from "../../../hooks/queries/useAgentAnalyticsQuery";
import useDelayedFlag from "../../../hooks/useDelayedFlag";
import KpiCard from "../../../components/analytics/KpiCard";
import TrendChart from "../../../components/analytics/TrendChart";
import CustomersTable from "../../../components/analytics/CustomersTable";
import LapsedCustomersTable from "../../../components/analytics/LapsedCustomersTable";
import AnalyticsSkeleton from "../../../components/analytics/AnalyticsSkeleton";
import { formatCurrency, formatNumber } from "../../../components/analytics/analyticsFormat";
import "../../../styles/components/analytics.scss";

// 0025: dedicated analytics PAGE for Agent (dashboard nav card, behind AgentRoute). Scope is
// enforced SERVER-SIDE per 0024 — a no-assignment agent gets hasAssignments=false (empty state),
// never org-wide numbers (inherited from the unchanged backend + hook). ₪ = site ex-VAT.
const AgentAnalyticsPageComponent = () => {
  const { data, isLoading, isError } = useAgentAnalyticsQuery();
  const showSkeleton = useDelayedFlag(isLoading);

  // The lapsed KPI is the actionable one: red when there are lapsed customers, green when none.
  const lapsedTone = data && data.lapsedCustomersCount > 0 ? "red" : "green";

  return (
    <div className="analyticsPage" dir="rtl">
      <div className="analyticsPageHeader">
        <Link to=".." className="analyticsBackLink">
          <i className="fa-solid fa-arrow-right"></i> חזרה לאיזור הסוכן
        </Link>
        <h1 className="analyticsPageTitle">סקירת הלקוחות שלי</h1>
        <p className="analyticsPageSubtitle">
          מבוסס על הזמנות הלקוחות המשויכים אליך (מחזור לפני מע״מ) — נתוני האתר
        </p>
      </div>

      {isLoading ? (
        showSkeleton && <AnalyticsSkeleton />
      ) : isError || !data ? (
        <p className="analyticsEmpty">לא ניתן לטעון נתונים כרגע</p>
      ) : !data.hasAssignments ? (
        <p className="analyticsEmpty">לא משויכים אליך לקוחות עדיין — אין נתונים להצגה</p>
      ) : (
        <>
          <div className="analyticsKpiGrid">
            <KpiCard
              tone="green"
              label="המחזור שלי החודש (לפני מע״מ)"
              value={formatCurrency(data.kpis.revenueThisMonth)}
              icon="fa-solid fa-shekel-sign"
            />
            <KpiCard
              tone="blue"
              label="ההזמנות שלי החודש"
              value={formatNumber(data.kpis.ordersThisMonth)}
              icon="fa-solid fa-shopping-bag"
            />
            <KpiCard
              tone="green"
              label="לקוחות פעילים (30 יום)"
              value={formatNumber(data.kpis.activeCustomers)}
              icon="fa-solid fa-user-check"
            />
            <KpiCard
              tone={lapsedTone}
              label="לקוחות לא פעילים (30+ ימים)"
              value={formatNumber(data.lapsedCustomersCount)}
              icon="fa-solid fa-user-clock"
            />
          </div>

          <TrendChart data={data.trend} />

          <div className="analyticsTwoCol">
            <LapsedCustomersTable rows={data.lapsedCustomers} />
            <CustomersTable title="הלקוחות המובילים שלי לפי מחזור" rows={data.topCustomers} accent="green" />
          </div>
        </>
      )}
    </div>
  );
};

export default AgentAnalyticsPageComponent;
